import { render, staticRenderFns } from "./VisitChargesModal.vue?vue&type=template&id=bdd1be6a&scoped=true"
import script from "./VisitChargesModal.vue?vue&type=script&lang=js"
export * from "./VisitChargesModal.vue?vue&type=script&lang=js"
import style0 from "./VisitChargesModal.vue?vue&type=style&index=0&id=bdd1be6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd1be6a",
  null
  
)

export default component.exports